<template>
  <div class="table_wrap member">
    <span class="total_length pb10">총 {{ paginationData.total }}개 </span>
    <el-table class="list-table" header-cell-class-name="list-header"
              style="width: 100%;" height="695" empty-text="데이터가 없습니다."
              :data="curationData"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column
          label="상태" width="90" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnStatus(scope.row.i_status) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="카테고리" width="90" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{ scope.row.ic_name }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="에디션" width="" class-name="text-center" prop="mb_nick">
        <template slot-scope="scope">
                    <span>
                        {{ returnEdition(scope.row.im_edition) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="타입" width="" class-name="text-center" prop="i_type">
        <template slot-scope="scope">
                    <span>
                        {{ returnType(scope.row.i_type) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="제목" width="" class-name="text-center" prop="i_name"></el-table-column>
      <el-table-column label="창작자" width="" class-name="text-center" prop="m_nick"></el-table-column>
      <el-table-column label="소유자" width="" class-name="text-center" prop="provider_nick"></el-table-column>
      <el-table-column label="큐레이션일시" width="" class-name="text-center" prop="c_title">
        <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.created_at,'YYYY-MM-DD HH:mm') }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column
          label="옵션" width="" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info ">
            <div class="row-info pointer" @click="moveDetail(scope.row.i_idx)">
              [상세]
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {categoryType} from "@/service/competitionService";
import dateMixins from "@/mixins/dateMixins";

export default {
  name: "CurationListDefaultLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    curationData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {
      idx: 1,
      categoryType: categoryType
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveDetail(idx) {
      // console.log(idx)
      this.$router.push(`/item/list/${idx}`);
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnStatus(status) {
      switch (status) {
        case 'auction' : {
          return '프리미엄 경매'
        }
        case 'pricetag' : {
          return '프리미엄 지정가 판매'
        }
        case 'nosale' : {
          return '판매안함'
        }
        default : {
          return '프리미엄 인수 대기'
        }
      }
    },
    returnEdition(edition) {
      switch (edition) {
        case 0 : {
          return '에디션'
        }
        case 1 : {
          return '싱글'
        }
        default : {
          return '-'
        }
      }
    },
    returnType(type){
      switch (type) {
        case 'digital' : {
          return '디지털'
        }
        case 'real' : {
          return '실물'
        }
        default : {
          return '-'
        }
      }
    },
    // returnCategoryName(value) {
    //   let keys = Object.keys(this.categoryType)
    //   let category = keys.filter(category => Number(category) === value);
    //   return this.categoryType[category].name
    // },
  },
  watch: {},
}
</script>

<style scoped>

</style>
